var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadArrowTop({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 17,
    r: 17,
    fill: "#377FFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.7875 9.3028C17.5792 9.10892 17.2967 9 17.0022 9C16.7077 9 16.4253 9.10892 16.217 9.3028L12.3297 12.9225C12.1728 13.067 12.0658 13.2516 12.022 13.4529C11.9783 13.6542 12 13.863 12.0842 14.0528C12.1684 14.2426 12.3114 14.4048 12.495 14.5186C12.6785 14.6325 12.8944 14.6929 13.1149 14.6921H15.0586C15.0951 14.6919 15.1312 14.6985 15.165 14.7115C15.1988 14.7244 15.2294 14.7435 15.2552 14.7675C15.2811 14.7915 15.3015 14.8201 15.3154 14.8515C15.3293 14.883 15.3364 14.9166 15.3362 14.9506V22.4487C15.3362 22.8601 15.5118 23.2547 15.8242 23.5456C16.1366 23.8366 16.5604 24 17.0022 24C17.4441 24 17.8678 23.8366 18.1803 23.5456C18.4927 23.2547 18.6682 22.8601 18.6682 22.4487V14.9506C18.6681 14.9166 18.6752 14.883 18.6891 14.8515C18.703 14.8201 18.7234 14.7915 18.7492 14.7675C18.775 14.7435 18.8057 14.7244 18.8395 14.7115C18.8732 14.6985 18.9094 14.6919 18.9459 14.6921H20.8896C21.1092 14.692 21.3239 14.6314 21.5065 14.5177C21.6891 14.4041 21.8314 14.2426 21.9155 14.0536C21.9995 13.8647 22.0215 13.6568 21.9787 13.4562C21.9358 13.2556 21.8301 13.0713 21.6748 12.9267L17.7875 9.3028Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadArrowTop);
export default __webpack_public_path__ + "static/media/upload-arrow-top.5748009e816bd2ac4c771fab100be8b8.svg";
export { ForwardRef as ReactComponent };